import { useFeatureMutation } from '@common/hooks/query/useFeatureMutation'; // Add this!
import { useAuthentication } from '@features/authentication';
import { useSelectedProductionId } from '@features/productions';
import { useShareClipSequenceMutation } from '../api/shareApi';
import { ShareableItem, SharePayload } from '../types';

export const useShareAction = () => {
    const productionId = useSelectedProductionId();
    const { email: currentUserEmail } = useAuthentication();

    const { execute: executeSequence, ...mutationState } = useFeatureMutation(
        useShareClipSequenceMutation,
    );

    const executeShare = async (
        validItems: ShareableItem[],
        payload: SharePayload,
    ) => {
        if (!productionId || !validItems.length) return;

        const { emails: recipients, message, notify: notifySender } = payload;

        const title = `${validItems[0].name}${
            validItems.length > 1 ? ` + ${validItems.length - 1} more` : ''
        }`;
        const clipIds = validItems.map((item) => item.id);

        const emailSet = new Set(recipients);
        if (notifySender && currentUserEmail) {
            emailSet.add(currentUserEmail);
        }

        return await executeSequence({
            productionId,
            title,
            clipIds,
            emails: Array.from(emailSet),
            description: message,
        });
    };

    return { executeShare, ...mutationState };
};
